import React from "react";
import { useTranslation } from "react-i18next";
import { Badge } from "reactstrap";

import { PAYMENT_STATUS } from "@constants/Bookings";
import { PaymentMethodProps } from "@models/components/user.model";

const PaymentMethod: React.FC<PaymentMethodProps> = ({
  isStatus = false,
  label,
  value,
}) => {
  const { t } = useTranslation();

  const getBadgeStatus = (): string => {
    let badgeType = "";

    if (value == "" || value == "untracked") return badgeType;

    if (isStatus) {
      switch (value.toUpperCase()) {
        case PAYMENT_STATUS.INITIATED:
        case PAYMENT_STATUS.PARTPAYMENT:
          badgeType = "warning";
          break;
        case PAYMENT_STATUS.SUCCESS:
        case PAYMENT_STATUS.PAID:
          badgeType = "success";
          break;
        case PAYMENT_STATUS.FAILED:
        case PAYMENT_STATUS.CANCELLED:
          badgeType = "danger";
          break;
        case PAYMENT_STATUS.BILLED:
          badgeType = "primary";
          break;
      }
    }
    return badgeType;
  };

  return (
    <div className="fg-guest-count-form" data-testid="paymentMethod-test">
      <h5 data-testid="paymentMethodLabel">{label}</h5>
      {isStatus ? (
        value != "" && value.toLocaleUpperCase() != PAYMENT_STATUS.UNTRACKED ? (
          <Badge data-testid="payment-type" color={getBadgeStatus()}>
            {t(value)}
          </Badge>
        ) : (
          "-"
        )
      ) : (
        <div className="fg-payment-btn-wrap" data-testid="paymentMethodValue">
          <div className="btn fg-btn fg-payment-btn active">
            <h6 className="mb-0" data-testid="payment-type">
              {t(value) || ""}
            </h6>
          </div>
        </div>
      )}
    </div>
  );
};

export default PaymentMethod;
